<template>
    <b-row>
        <b-col>
            <b-row>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Paziente</label>
                    <span> {{ jsonDataAccettazione.paziente }}</span>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Ingresso</label>
                    <date-picker v-model="jsonData.dataIngresso" format="DD-MM-YYYY" value-type="timestamp" type="date" placeholder="Seleziona una data ingresso" :disabled="true"></date-picker>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">SITUAZIONE ATTUALE ( Patologia/e da cui è affetto il pziente, menomazioni e disabilità situazione socio-ambientale):</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.situazioneAttuale"> </b-form-input>
                    <span v-else>{{ jsonData.situazioneAttuale }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">ESITI COMPLESSIVI ATTESI NEL LUNGO TERMINE ( OUTCOME GLOBALE) ( sul piano della menomazione, disabilità, livello d'integrazione sociale) in funzione degli elementi indicati nel primo punto, delle risorse disponibili, dei bisogni e delle preferenze del paziente(e/o dei suoi familiari quando è opportuno):</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.esitiComplessiviAttesiLungoTermne" :readonly="isReadOnly"></b-form-input>
                    <span v-else>{{ jsonData.esitiComplessiviAttesiLungoTermne }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">"OUTCOME FUNZIONALE" o ESITO ATTESO AL TERMINE DEL RICOVERO ( E TEMPO PREVISTO DI RICOVERO) e ESITI SPECIFICI:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.esitoAttesoTermineRicovero" :readonly="isReadOnly"> </b-form-input>
                    <span v-else>{{ jsonData.esitoAttesoTermineRicovero }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">FASI E MODALITA' di intervento del team riabilitativo in funzione degli esiti attesi:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.fasiModalita" :readonly="isReadOnly"></b-form-input>
                    <span v-else>{{ jsonData.fasiModalita }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">POSSIBILE FABBISOGNO RIABILITATIVO ( medico e sociale), strutture e presidi da coinvolgere e modalità del loro inserimento nel progetto riabilitativo:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.possibileFabbisognoRiabilitativo" :readonly="isReadOnly"></b-form-input>
                    <span v-else>{{ jsonData.possibileFabbisognoRiabilitativo }}</span>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import datePicker from "vue2-datepicker";

export default {
    components: { datePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    data() {
        return {
            jsonData: {
                id: null,
                idAccettazione: null,
                dataIngresso: null,
                situazioneAttuale: null,
                esitiComplessiviAttesiLungoTermne: null,
                esitoAttesoTermineRicovero: null,
                fasiModalita: null,
                possibileFabbisognoRiabilitativo: null,
                params: "",
                nomeProgetto: "PROGETTO RIABILITATIVO INDIVIDUALE",
            },
            jsonDataAccettazione: {
                paziente: "",
            },
            pathResourceProgettoRiabilitativoIndividuale: "/rsapazientepriprogettoriabilitativoindividuale",
            nomeProgetto: "PROGETTO RIABILITATIVO INDIVIDUALE",
            params: "",
            pathResourceAccettazione: "/accettazioni",
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        let params = { progettoRiabilitativoIndividuale: "si" };
        me.params = JSON.stringify(params);
        me.jsonData = {
            idAccettazione: me.idAccettazione,
            dataIngresso: new Date().getTime(),
            fasiModalita: null,
            possibileFabbisognoRiabilitativo: null,
            esitoAttesoTermineRicovero: null,
            esitiComplessiviAttesiLungoTermne: null,
            situazioneAttuale: null,
            params: me.params,
            nomeProgetto: "PROGETTO RIABILITATIVO INDIVIDUALE",
        };
        this.jsonDataAccettazione = {
            paziente: "",
        };
        me.loadDataAccettazione();
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProgettoRiabilitativoIndividuale + "/" + me.idRisorsa, {}, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
        },
        loadDataError(error) {
            console.log(error);
        },

        loadDataAccettazione() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceAccettazione + "/" + me.idAccettazione, {}, me.loadAccettazioneSuccess, me.loadAccettazioneError);
        },
        loadAccettazioneSuccess(response) {
            let me = this;
            me.jsonDataAccettazione.paziente = response.data.data.accettazioneAnagrafica.nome + " " + response.data.data.accettazioneAnagrafica.cognome;
            me.jsonData.dataIngresso = response.data.data.dataAccettazione;
        },
        loadAccettazioneError(error) {
            console.log(error);
        },
    },
};
</script>
